const REMEMBERED_PATH = 'redirect_url';

export default REMEMBERED_PATH;
